/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Recordingsettings1Inputs */

const en_entity_recordingsettings1 = /** @type {(inputs: Entity_Recordingsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording Settings`)
};

const de_entity_recordingsettings1 = /** @type {(inputs: Entity_Recordingsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Recording Settings" |
*
* @param {Entity_Recordingsettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_recordingsettings1 = /** @type {((inputs?: Entity_Recordingsettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Recordingsettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_recordingsettings1(inputs)
	return de_entity_recordingsettings1(inputs)
});
export { entity_recordingsettings1 as "entity_recordingSettings" }